import { PERMISSIONS_GLOBAL, SECTIONS_ALL } from 'constants/permissions';

interface SectionType {
  [key: string]: number;
}

export const findSectionName = (params: string[]): SectionType => {
  return params.reduce((accumulator: SectionType, currentValue: string) => {
    if (SECTIONS_ALL[currentValue]) {
      return {
        currentValue: SECTIONS_ALL[currentValue],
        ...accumulator
      };
    }

    return {};
  }, {});
};

export const findSectionValue = (
  params: string[],
  section: number
): SectionType => {
  return params.reduce((accumulator: SectionType, currentValue: string) => {
    if (PERMISSIONS_GLOBAL[section]) {
      return {
        currentValue: PERMISSIONS_GLOBAL[section][currentValue],
        ...accumulator
      };
    }

    return {};
  }, {});
};

/**
 * Bitmask test. Both sides are coerced because the permission catalog and the
 * role rows carry these as STRINGS — the columns are `bigint`, which the pg
 * driver returns as text. `(required & value) === required` compares the
 * number the bitwise operator produces against the raw argument, so a string
 * `required` never matched and every checkbox rendered unchecked.
 */
export const checkPermission = (
  required: number | string,
  value: number | string
) => {
  const bit = Number(required);
  const mask = Number(value);

  return (bit & mask) === bit;
};
